import { render, staticRenderFns } from "./create.vue?vue&type=template&id=5c5dc7b1&scoped=true&lang=html&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5dc7b1",
  null
  
)

export default component.exports